import script from "./uploadPicDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./uploadPicDialog.vue?vue&type=script&lang=ts&setup=true"

import "./uploadPicDialog.vue?vue&type=style&index=0&id=8b8bbccc&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b8bbccc"]])

export default __exports__